module.exports = {
  "NAME": "prod",
  "API": {
    "BASE_URL": "https://api.pointr.co/api",
    "REQUEST_TIMEOUT": 15000,
    "REQUEST_DELAY": 1000
  },
  "DEBUG": {
    "ENABLED": false
  },
  "SENTRY": {
    "ENABLED": true,
    "URL": "https://e9fd69f39ac549ebb80d3a4e20d46f73@sentry.io/1279623"
  },
  "MKT_PAGES": {
    "BASE_URL": "https://pointr.co",
    "OUR_SOLUTION": "https://pointr.co/our-solution",
    "ABOUT": "https://pointr.co/about"
  },
  "SITE": {
    "BASE_URL": "",
    "WEBAPP_URL": "https://app.pointr.co",
    "ENTERPRISE_WEBAPP_URL": "https://ENTERPRISE_ID.enterprise.pointr.co"
  },
  "CLIENT_TYPE": "WebApp",
  "ENTERPRISE_API": {
    "BASE_URL": "https://ENTERPRISE_ID-api.enterprise.pointr.co"
  },
  "AUTHENTICATION_SERVICE": {
    "API_URL": "https://apiauth.pointr.co",
    "WEB_URL": "https://auth.pointr.co"
  },
  "VERSION": "3.0.0"
}